var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useLanguage } from '../context/LanguageContext';
import '../../styles/LanguageSelector.css';
var languageOptions = [
    { code: 'en', flag: 'gb' },
    { code: 'fr', flag: 'fr' },
    { code: 'de', flag: 'de' },
    { code: 'es', flag: 'es' },
    { code: 'pl', flag: 'pl' },
    { code: 'pt', flag: 'pt' },
];
var getFlagByCode = function (code) {
    var found = languageOptions.find(function (lang) { return lang.code === code; });
    return (found === null || found === void 0 ? void 0 : found.flag) || code; // fallback au cas où
};
export default function LanguageSelector() {
    var _a = useLanguage(), language = _a.language, setLanguage = _a.setLanguage;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var toggleDropdown = function () { return setOpen(!open); };
    return (_jsxs("div", __assign({ className: "language-selector-container" }, { children: [_jsx(Button, { className: "language-toggle language-btn".concat(open ? ' open' : ''), style: { backgroundImage: "url('https://flagcdn.com/w2560/".concat(getFlagByCode(language), ".png')") }, onClick: toggleDropdown }), open && (_jsx("div", __assign({ className: "language-options" }, { children: languageOptions.map(function (option) { return (_jsx(Button, { style: { backgroundImage: "url('https://flagcdn.com/w2560/".concat(option.flag, ".png')") }, className: "language-btn".concat(language === option.code ? ' selected' : ''), onClick: function () {
                        setLanguage(option.code);
                        setOpen(false);
                    } }, option.code)); }) })))] })));
}
